import React from "react";

import { Pagination, Table as CSTable } from "clearsense-ui/components";

import { COLUMN_DATA } from "./columns";

import { MINIMUM_PAGE_SIZE, PAGE_SIZE_INCREMENT } from "../constants";

const Table = ({
  isLoading,
  whatIfs,
  handleClick,
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
}) => (
  <div className="bg-white">
    <CSTable
      rowData={whatIfs?.data}
      isLoading={isLoading}
      rowKey={record => record.id}
      columnData={COLUMN_DATA}
      onRowClick={(_, { id }) => handleClick(id)}
      data-cy="whatif-analysis-table"
    />
    {whatIfs?.count > pageSize && (
      <Pagination
        className="p-6 m-0"
        totalRecordsCount={whatIfs?.count}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        showResultsPerPage
        setPageSize={setPageSize}
        pageSizeOptionsList={Array.from(
          { length: MINIMUM_PAGE_SIZE },
          (_, index) => index + PAGE_SIZE_INCREMENT
        )}
      />
    )}
  </div>
);

export default Table;
